import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@piplapps/pipl-ui';
import Popup from 'reactjs-popup';
import { Helmet } from 'react-helmet';
import TeamsTable from './TeamsTable';
import styles from './Teams.module.less';
import DisableTeamManagementModal from './DisableTeamManagementModal';
import CreateTeamModal from './CreateTeamModal';
import ConnectedModals from './ConnectedModals';
import AnalyticsEventNames from '../../../Utils/AnalyticsHandler/AnalyticsEventNames';
import AnalyticsHandler from '../../../Utils/AnalyticsHandler/AnalyticsHandler';

const Teams = (props) => {
  const modalStyle = {
    width: '528px',
    boxShadow: 'rgba(101, 101, 101, 0.28) 0px 4px 12px 0px',
    border: 'none',
    borderRadius: '8px',
    padding: '40px 80px',
    backgroundColor: '#ffffff',
  };
  const teamsColumns = [
    {
      Header: gettext(`Teams (${props.teams?.length || 0})`),
      accessor: 'name',
      id: 0,
    },
    {
      Header: gettext('Users'),
      accessor: 'members',
      sortType: 'basic',
      id: 1,
    },
  ];

  const columns = useMemo(() => teamsColumns);
  return (
    <div>
      <Helmet>
        <title>{gettext('Teams')}</title>
      </Helmet>
      {props.isTeamManagement ? (
        <div>
          <div className={styles.text}>
            {gettext(
              'Create the teams for your organization here. Once you add a team, navigate to the Users page to assign users.',
            )}
          </div>
          <div className={[styles.buttonWrapper, styles.createButton].join(' ')}>
            <Button
              buttonClass="primary-blue"
              text={gettext('+ Create a team')}
              onClick={() => props.clickedCreateTeamButton()}
              id="create-team-button"
            />
          </div>
          <div>
            <TeamsTable columns={columns} data={props.teams ? props.teams : []} isLoading={false} tableProps={props} />
          </div>
        </div>
      ) : null}
      <div>
        <span className={styles.text}>
          {props.isTeamManagement
            ? gettext(
                'By disabling team management, all users will be unassigned from their team, and all teams will be deleted.',
              )
            : gettext('Enabling team management allows you to better manage your users by grouping them into teams. ')}
        </span>
        <div className={styles.buttonWrapper}>
          {!props.isTeamManagement ? (
            <AnalyticsHandler eventName={AnalyticsEventNames.ENABLE_TEAM_MANAGEMENT}>
              <Button
                buttonClass="primary-blue"
                text={gettext('Enable team management')}
                onClick={() => props.onEnableTeamManagement()}
                id="enable-team-management-button"
              />
            </AnalyticsHandler>
          ) : (
            <Button
              buttonClass="secondary-red"
              text={gettext('Disable team management')}
              onClick={() => props.clickedDisableTeamManagementButton()}
              id="disable-team-management-button"
            />
          )}
        </div>
        <Popup
          onClose={() => props.clickedCloseModalButton()}
          contentStyle={modalStyle}
          modal
          open={props.disableTeamManagementModalOpen}
        >
          {() => <DisableTeamManagementModal clickedCloseModalButton={props.clickedCloseModalButton} />}
        </Popup>
        <Popup onClose={props.clickedCloseModalButton} contentStyle={modalStyle} modal open={props.createTeamModalOpen}>
          {() => (
            <CreateTeamModal
              clickedCloseModalButton={props.clickedCloseModalButton}
              title={gettext('Create a team')}
              teams={props.teams}
            />
          )}
        </Popup>
        <ConnectedModals actions={props.actions} />
      </div>
    </div>
  );
};

Teams.propTypes = {
  teams: PropTypes.array,
  clickedCreateTeamButton: PropTypes.func,
  clickedDisableTeamManagementButton: PropTypes.func,
  isTeamManagement: PropTypes.bool,
  onEnableTeamManagement: PropTypes.func,
  disableTeamManagementModalOpen: PropTypes.bool,
  createTeamModalOpen: PropTypes.bool,
  clickedCloseModalButton: PropTypes.func,
  actions: PropTypes.array,
};

export default Teams;
